module.exports = __webpack_public_path__ + "assets/user.aed0fcda.svg";